(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gh-faq"] && !Shopify.designMode) return;
  try {
    
  function ghFaqAccordionInit(scope) {
    (scope || document).querySelectorAll('[data-gh-faq-accordion]').forEach(function (accordion) {
      if (accordion.dataset.ghFaqBound === '1') return;
      accordion.dataset.ghFaqBound = '1';
      accordion.querySelectorAll('.gh-faq__item').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          accordion.querySelectorAll('.gh-faq__item[open]').forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
      /* Chromium quirk: display:flex on <summary> breaks the native Enter/Space
         keyboard-invoke (WCAG 2.1.1). Delegated keydown replays the same click path
         (summary.click()) so the toggle listener above still enforces single-open. */
      accordion.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var summary = event.target.closest('.gh-faq__question');
        if (!summary) return;
        event.preventDefault();
        summary.click();
      });
    });
  }
  ghFaqAccordionInit();
  document.addEventListener('shopify:section:load', function (event) { ghFaqAccordionInit(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gh-quiz-band"] && !Shopify.designMode) return;
  try {
    
  function ghQuizStickyInit(scope) {
    (scope || document).querySelectorAll('.gh-quiz-sticky').forEach(function (bar) {
      if (sessionStorage.getItem('gh-quiz-sticky-dismissed') === '1') bar.style.display = 'none';
      var dismiss = bar.querySelector('.gh-quiz-sticky__dismiss');
      if (dismiss) {
        dismiss.addEventListener('click', function () {
          bar.style.display = 'none';
          sessionStorage.setItem('gh-quiz-sticky-dismissed', '1');
        });
      }
    });
  }
  ghQuizStickyInit();
  document.addEventListener('shopify:section:load', function (event) { ghQuizStickyInit(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ghp-offer"] && !Shopify.designMode) return;
  try {
    
  /* Thumbnail rail only. Swipe, dots and reduced-motion are already handled by
     the shared carousel script through the data-gh-carousel contract on the
     same root; it re-reads scrollLeft once a scroll settles, so a rail click
     keeps the dots in sync without either script knowing about the other. */
  function ghpOfferGalleryInit() {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-ghp-gallery]').forEach(function (root) {
      if (root.dataset.ghpGalleryInit === '1') return;
      var track = root.querySelector('[data-gh-track]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ghp-thumb]'));
      if (!track || thumbs.length < 2) return;
      root.dataset.ghpGalleryInit = '1';

      function slideWidth() {
        var first = track.firstElementChild;
        return first ? first.getBoundingClientRect().width : 0;
      }

      /* The rail is one sliding row, so the active thumbnail can sit outside it.
         Nudging the rail's own scrollLeft keeps the page still — scrollIntoView
         would walk up and move the document too. */
      function revealThumb(thumb) {
        var rail = thumb.parentElement;
        if (!rail || rail.scrollWidth <= rail.clientWidth) return;
        var left = thumb.offsetLeft;
        var right = left + thumb.offsetWidth;
        var target = null;
        if (left < rail.scrollLeft) target = left - 8;
        else if (right > rail.scrollLeft + rail.clientWidth) target = right - rail.clientWidth + 8;
        if (target === null) return;
        rail.scrollTo({ left: Math.max(0, target), behavior: reduced ? 'auto' : 'smooth' });
      }

      function setActive(index) {
        var i = Math.max(0, Math.min(index, thumbs.length - 1));
        thumbs.forEach(function (thumb, n) {
          var on = n === i;
          thumb.classList.toggle('is-active', on);
          if (on) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
        revealThumb(thumbs[i]);
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          var width = slideWidth();
          if (width) {
            track.scrollTo({ left: i * width, behavior: reduced ? 'auto' : 'smooth' });
          }
          setActive(i);
        });
      });

      var settle;
      track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () {
          var width = slideWidth();
          setActive(width ? Math.round(track.scrollLeft / width) : 0);
        }, 90);
      }, { passive: true });
    });
  }

  ghpOfferGalleryInit();
  document.addEventListener('shopify:section:load', function () { ghpOfferGalleryInit(); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ghp-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  function ghpStickyAtcTeardown(root) {
    if (root.dataset.ghpSatcInit !== '1') return;
    delete root.dataset.ghpSatcInit;
    if (root.ghpSatcObserver) {
      root.ghpSatcObserver.disconnect();
      root.ghpSatcObserver = null;
    }
    var bar = root.querySelector('.ghp-satc__bar');
    if (bar) {
      bar.classList.remove('ghp-satc__bar--visible');
      bar.setAttribute('aria-hidden', 'true');
      bar.setAttribute('inert', '');
    }
    document.body.classList.remove('ghp-satc-open');
  }

  function ghpStickyAtcInit() {
    document.querySelectorAll('.ghp-satc').forEach(function (root) {
      if (root.dataset.ghpSatcInit === '1') return;
      var bar = root.querySelector('.ghp-satc__bar');
      var offer = document.getElementById('ghp-buy');
      // 'hero': the bar rides along from the moment the hero scrolls out, and only
      // steps aside while the offer section itself is on screen (its own buy UI).
      // Clarity 2026-08: la mayoria no llegaba a la seccion 10 (la oferta) y por
      // tanto JAMAS veia la barra — no habia camino de compra durante la lectura.
      // 'offer' keeps the old behaviour: appear only after scrolling past the offer.
      var mode = root.dataset.ghpSatcMode === 'offer' ? 'offer' : 'hero';
      var hero = document.querySelector('.ghp-hero');
      if (mode === 'hero' && !hero) mode = 'offer';
      var trigger = mode === 'hero' ? hero : offer;
      if (!bar || !trigger) return;
      root.dataset.ghpSatcInit = '1';
      var visible = false;
      var triggerPassed = false;
      var offerOnScreen = false;
      var apply = function () {
        var shouldShow = triggerPassed && !(mode === 'hero' && offerOnScreen);
        if (shouldShow === visible) return;
        visible = shouldShow;
        bar.classList.toggle('ghp-satc__bar--visible', shouldShow);
        bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        if (shouldShow) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
        document.body.classList.toggle('ghp-satc-open', shouldShow);
      };
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === trigger) {
            triggerPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          }
          if (mode === 'hero' && entry.target === offer) {
            offerOnScreen = entry.isIntersecting;
          }
        });
        apply();
      }, { threshold: 0 });
      root.ghpSatcObserver = observer;
      observer.observe(trigger);
      if (mode === 'hero' && offer) observer.observe(offer);
    });
  }

  ghpStickyAtcInit();
  document.addEventListener('shopify:section:load', function () { ghpStickyAtcInit(); });
  document.addEventListener('shopify:section:unload', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;
    target.querySelectorAll('.ghp-satc').forEach(ghpStickyAtcTeardown);
    if (target.querySelector('#ghp-buy')) {
      document.querySelectorAll('.ghp-satc').forEach(ghpStickyAtcTeardown);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glomend-header"]) return;
  try {
    
  function ghHeaderOpenDrawer(root) {
    var toggle = root.querySelector('.gh-header__hamburger');
    var drawer = root.querySelector('.gh-header__drawer');
    var backdrop = root.querySelector('.gh-header__drawer-backdrop');
    if (!toggle || !drawer) return;
    drawer.hidden = false;
    if (backdrop) backdrop.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        if (backdrop) backdrop.classList.add('is-open');
      });
    });
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    /* Focus the drawer's own container (tabindex="-1" in the markup) rather than "the first
       focusable descendant" — that used to resolve to a link buried inside the still-closed
       "Shop all" accordion panel, which isn't focusable, so .focus() silently no-op'd. */
    drawer.focus({ preventScroll: true });
  }

  function ghHeaderCloseDrawer(root, returnFocus) {
    var toggle = root.querySelector('.gh-header__hamburger');
    var drawer = root.querySelector('.gh-header__drawer');
    var backdrop = root.querySelector('.gh-header__drawer-backdrop');
    if (!toggle || !drawer) return;
    drawer.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    window.setTimeout(function () {
      if (toggle.getAttribute('aria-expanded') === 'false') {
        drawer.hidden = true;
        if (backdrop) backdrop.hidden = true;
      }
    }, 260);
    if (returnFocus) toggle.focus();
  }

  function ghHeaderIsVisible(el) {
    return typeof el.checkVisibility === 'function' ? el.checkVisibility() : true;
  }

  function ghHeaderDrawerFocusables(drawer) {
    /* summary is natively focusable but a plain "a, button" selector missed it, so
       Shift+Tab from "Shop all" (the real first stop in the tab order) never matched the
       trap's "first" element and escaped the drawer into the page behind it. Visibility-
       filtered so links inside a still-closed accordion panel aren't counted as tab stops. */
    return Array.prototype.filter.call(
      drawer.querySelectorAll('a, button:not([disabled]), summary'),
      ghHeaderIsVisible
    );
  }

  function ghHeaderInit(scope) {
    (scope || document).querySelectorAll('.gh-header').forEach(function (root) {
      if (root.dataset.ghHeaderReady) return;
      root.dataset.ghHeaderReady = '1';

      var desktopMq = window.matchMedia('(min-width: 750px)');
      var hoverMq = window.matchMedia('(hover: hover) and (pointer: fine)');

      /* Desktop hover-open enhancement on top of a fully JS-owned click toggle (ref's
         onMouseEnter={openX} / onMouseLeave={closeMenus}). The click handler below calls
         preventDefault() so the native <details> toggle never fires — otherwise hover
         pre-opening the panel and the user's click toggling that same `open` property raced
         each other, and the click instantly closed what hover had just opened. */
      root.querySelectorAll('.gh-header__dropdown').forEach(function (dropdown) {
        var summary = dropdown.querySelector('summary');
        var closeTimer;

        function closeSiblingDropdowns() {
          /* name-grouped <details> already close siblings natively when `.open` is set via
             script, but that's asserted here explicitly rather than relied on silently. */
          root.querySelectorAll('.gh-header__dropdown[open]').forEach(function (other) {
            if (other === dropdown) return;
            other.open = false;
            other.dataset.ghOpenSource = '';
          });
        }

        function setDropdownOpen(isOpen, source) {
          clearTimeout(closeTimer);
          if (isOpen) {
            closeSiblingDropdowns();
            dropdown.open = true;
            dropdown.dataset.ghOpenSource = source || 'click';
          } else {
            dropdown.open = false;
            dropdown.dataset.ghOpenSource = '';
          }
        }

        dropdown.addEventListener('mouseenter', function () {
          if (!desktopMq.matches || !hoverMq.matches) return;
          clearTimeout(closeTimer);
          if (!dropdown.open) setDropdownOpen(true, 'hover');
        });

        dropdown.addEventListener('mouseleave', function () {
          if (!desktopMq.matches || !hoverMq.matches) return;
          /* Only auto-close what hover itself opened — a click "claims" the open state in
             the handler below and must not be closed just because the pointer drifted off. */
          if (dropdown.dataset.ghOpenSource !== 'hover') return;
          closeTimer = setTimeout(function () {
            setDropdownOpen(false);
          }, 60);
        });

        if (summary) {
          summary.addEventListener('click', function (event) {
            event.preventDefault();
            clearTimeout(closeTimer);
            if (dropdown.open) {
              if (dropdown.dataset.ghOpenSource === 'hover') {
                /* Already open from hover: this click claims it (so the *next* click closes
                   it) instead of toggling it shut immediately. */
                dropdown.dataset.ghOpenSource = 'click';
                return;
              }
              setDropdownOpen(false);
            } else {
              setDropdownOpen(true, 'click');
            }
          });
        }
      });

      /* Mobile full-height drawer */
      var drawerToggle = root.querySelector('.gh-header__hamburger');
      var drawer = root.querySelector('.gh-header__drawer');
      var backdrop = root.querySelector('.gh-header__drawer-backdrop');
      if (drawerToggle && drawer) {
        drawerToggle.addEventListener('click', function () {
          if (drawerToggle.getAttribute('aria-expanded') === 'true') ghHeaderCloseDrawer(root, false);
          else ghHeaderOpenDrawer(root);
        });

        if (backdrop) {
          backdrop.addEventListener('click', function () {
            ghHeaderCloseDrawer(root, false);
          });
        }

        drawer.addEventListener('keydown', function (event) {
          if (event.key !== 'Tab') return;
          var focusables = ghHeaderDrawerFocusables(drawer);
          if (!focusables.length) return;
          var first = focusables[0];
          var last = focusables[focusables.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });

        /* Chromium quirk: display:flex on <summary> breaks the native Enter/Space
           keyboard-invoke (WCAG 2.1.1) — same issue as gh-faq's accordion. Delegated
           keydown replays the toggle the way a click would (summary.click()). */
        drawer.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          var summary = event.target.closest('.gh-header__drawer-trigger');
          if (!summary) return;
          event.preventDefault();
          summary.click();
        });
      }

      /* Downstream components (cart drawer offset, anchors) read these variables. */
      function setHeaderHeightVars() {
        var height = root.offsetHeight;
        document.body.style.setProperty('--header-height', height + 'px');
        document.body.style.setProperty('--header-group-height', height + 'px');
      }
      setHeaderHeightVars();
      window.addEventListener('resize', setHeaderHeightVars);
    });
  }

  /* Both keydown listeners below used to live inside the per-root forEach above, so every
     shopify:section:load re-render (which replaces the header's DOM outright) registered a
     fresh pair of document-level listeners on top of the still-live old ones — an unbounded
     leak across editor re-renders. Hoisted to module scope so each is registered exactly
     once; they look up whatever is currently open in the live document instead of closing
     over one specific root, matching assets/gh-carousel.js's module-scope-listener pattern. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openDropdown = document.querySelector('.gh-header__dropdown[open]');
    if (!openDropdown) return;
    openDropdown.open = false;
    openDropdown.dataset.ghOpenSource = '';
    var trigger = openDropdown.querySelector('summary');
    if (trigger) trigger.focus();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openToggle = document.querySelector('.gh-header__hamburger[aria-expanded="true"]');
    if (!openToggle) return;
    var root = openToggle.closest('.gh-header');
    if (!root) return;
    ghHeaderCloseDrawer(root, true);
  });

  ghHeaderInit();
  document.addEventListener('shopify:section:load', function (event) { ghHeaderInit(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
